export enum SelectionColor {
  Purple,
  Blue,
  Pink,
  Orange,
}

function SquareColorPicker({
  selectedColor,
  onBoxClick,
}: {
  selectedColor: SelectionColor
  onBoxClick: (val: SelectionColor) => void
}): React.ReactElement {
  const boxClassName = 'w-14 h-14 rounded-small m-1 cursor-pointer transition duration-200 '
  return (
    <div className="flex">
      <div
        className={`${boxClassName} ${
          selectedColor === SelectionColor.Blue && 'border-4 border-black'
        } bg-blue-logo hover:drop-shadow-blue`}
        onClick={() => onBoxClick(SelectionColor.Blue)}
      />
      <div
        className={`${boxClassName} ${
          selectedColor === SelectionColor.Purple && 'border-4 border-black'
        } bg-purple hover:drop-shadow-purple`}
        onClick={() => onBoxClick(SelectionColor.Purple)}
      />
      <div
        className={`${boxClassName} ${
          selectedColor === SelectionColor.Pink && 'border-4 border-black'
        } bg-hotpink hover:drop-shadow-pink`}
        onClick={() => onBoxClick(SelectionColor.Pink)}
      />
      <div
        className={`${boxClassName} ${
          selectedColor === SelectionColor.Orange && 'border-4 border-black'
        } bg-orange hover:drop-shadow-orange`}
        onClick={() => onBoxClick(SelectionColor.Orange)}
      />
    </div>
  )
}

export default SquareColorPicker
